const setSliders = () => {
  const swiperElement = document.querySelector("#swiper-work-detail");
  if (!swiperElement || typeof Swiper === "undefined") return;

  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 22,
    pagination: {
      el:
        window.innerWidth > 767
          ? ".swiper-pagination"
          : ".swiper-pagination-mobile",
      clickable: true,
    },
    navigation: {
      nextEl:
        window.innerWidth > 767
          ? ".swiper-button-next"
          : ".swiper-button-next-mobile",
      prevEl:
        window.innerWidth > 767
          ? ".swiper-button-prev"
          : ".swiper-button-prev-mobile",
    },
    breakpoints: {
      640: { slidesPerView: 1, slidesOffsetBefore: 16, slidesOffsetAfter: 16 },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
      },
      1024: { slidesPerView: 2.5, spaceBetween: 30, slidesOffsetAfter: 40 },
    },
  });
};

export default setSliders;
